export default {"src":"/_next/static/media/icon-cognia.be304d32.svg","height":16,"width":16};